var styleDataHash = "e68f7956";
const injectCss = (() => {
  var css = `@charset "UTF-8";.GpvJZ,.ReactModalPortal,._1-H0L,.glob_fontElementMap,button{font-family:var(--ricos-font-family,unset)}.xdgea{display:flex}.tbL5P:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.tbL5P:hover,.tkYiC{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}.tkYiC{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}._91Skf .tkYiC{box-shadow:none!important}._91Skf :is([data-resize-handle],[data-hook=image-corner-radius-handle],[data-hook=image-corner-radius-label]){display:none!important}.DhT6R{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.DhT6R.fqETV{pointer-events:none}._0iEPn ::selection{background:transparent}.C-kDf{display:none}.GpvJZ{position:relative}.QA34O{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}._2l79k{color:#333;text-decoration:none}._9AWVV{display:block}.VZbQA{position:relative}.qn8DA{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.qn8DA._7E1AC::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.qn8DA.TsQx0::-webkit-scrollbar-thumb{background-color:transparent}.rvUpc{max-width:max-content!important;min-width:100%}.qn8DA::-webkit-scrollbar{-webkit-appearance:none}.qn8DA::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.qn8DA::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "_1-H0L",
  "pluginContainer": "GpvJZ",
  "flex": "xdgea",
  "isFocusable": "tbL5P",
  "hasFocus": "tkYiC",
  "dragImageView": "_91Skf",
  "overlay": "DhT6R",
  "noPointerEventsOnFocus": "fqETV",
  "hideTextSelection": "_0iEPn",
  "hidden": "C-kDf",
  "pluginContainerMobile": "QA34O",
  "isImage": "_2l79k",
  "anchor": "_9AWVV",
  "horizontalScrollbarWrapper": "VZbQA",
  "pluginWithHorizontalScrollbar": "qn8DA",
  "show": "_7E1AC",
  "hide": "TsQx0",
  "horizontalScrollbar": "rvUpc"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
